// time picker

import Picker from 'pickerjs'

const INVALID_TIME_MESSAGE = 'Выберите время, которое еще не прошло'

function getDateInput(timeInput) {
  const form = timeInput.closest('form')

  return form ? form.querySelector('.form-field__date') : document.querySelector('.form-field__date')
}

function parseDate(value) {
  if (!value) {
    const today = new Date()

    return new Date(today.getFullYear(), today.getMonth(), today.getDate())
  }

  const parts = value.match(/^(\d{2})\.(\d{2})\.(\d{2}|\d{4})$/)

  if (!parts) {
    return null
  }

  const year = parts[3].length === 2 ? 2000 + Number(parts[3]) : Number(parts[3])
  const date = new Date(year, Number(parts[2]) - 1, Number(parts[1]))

  return date.getFullYear() === year
    && date.getMonth() === Number(parts[2]) - 1
    && date.getDate() === Number(parts[1])
    ? date
    : null
}

function isToday(date, today) {
  return date
    && date.getFullYear() === today.getFullYear()
    && date.getMonth() === today.getMonth()
    && date.getDate() === today.getDate()
}

function timeToMinutes(hours, minutes) {
  return hours * 60 + minutes
}

function isAllowedTime(time, dateInput) {
  const selectedDate = parseDate(dateInput ? dateInput.value : '')

  if (!selectedDate || !isToday(selectedDate, new Date())) {
    return true
  }

  const now = new Date()
  const selectedMinutes = timeToMinutes(time.getHours(), time.getMinutes())
  const currentMinutes = timeToMinutes(now.getHours(), now.getMinutes())

  return selectedMinutes > currentMinutes
}

function getPickerInstance(input) {
  if (!input.picker) {
    return null
  }

  return typeof input.picker.getDate === 'function' ? input.picker : input.picker.picker
}

function validatePickerTime(input, dateInput) {
  const picker = getPickerInstance(input)
  const selectedTime = picker && typeof picker.getDate === 'function' ? picker.getDate() : null

  if (input.getAttribute('data-min-time') !== 'now' || !selectedTime) {
    return true
  }

  const isAllowed = isAllowedTime(selectedTime, dateInput)

  return isAllowed
}

function validateManualTime(input, dateInput) {
  if (input.getAttribute('data-min-time') !== 'now') {
    return
  }

  if (!input.value) {
    input.setCustomValidity('')
    return
  }

  const parts = input.value.match(/^(\d{2}):(\d{2})$/)
  const hours = parts ? Number(parts[1]) : NaN
  const minutes = parts ? Number(parts[2]) : NaN
  const isValidFormat = Number.isInteger(hours)
    && Number.isInteger(minutes)
    && hours >= 0
    && hours <= 23
    && minutes >= 0
    && minutes <= 59
  const time = isValidFormat ? new Date() : null

  if (time) {
    time.setHours(hours, minutes, 0, 0)
  }

  input.setCustomValidity(time && isAllowedTime(time, dateInput) ? '' : INVALID_TIME_MESSAGE)
}

function clearInvalidTimeOnToday(input, dateInput) {
  if (input.getAttribute('data-min-time') !== 'now' || !input.value) {
    return
  }

  const selectedDate = parseDate(dateInput ? dateInput.value : '')

  if (!selectedDate || !isToday(selectedDate, new Date())) {
    return
  }

  const parts = input.value.match(/^(\d{2}):(\d{2})$/)
  const hours = parts ? Number(parts[1]) : NaN
  const minutes = parts ? Number(parts[2]) : NaN
  const isValidTime = Number.isInteger(hours)
    && Number.isInteger(minutes)
    && hours >= 0
    && hours <= 23
    && minutes >= 0
    && minutes <= 59

  if (!isValidTime) {
    return
  }

  const now = new Date()
  const selectedMinutes = timeToMinutes(hours, minutes)
  const currentMinutes = timeToMinutes(now.getHours(), now.getMinutes())

  if (selectedMinutes > currentMinutes) {
    return
  }

  input.value = ''
  input.setCustomValidity('')

  const picker = getPickerInstance(input)

  if (picker && typeof picker.update === 'function') {
    picker.update()
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const body = document.querySelector('body')
  const formFieldTime = document.querySelector('.form-field__time')
  const timeFormControl = document.querySelector('.time-form-control')
  const timePickerContainer = document.querySelector('.time-picker-container')

  if (!body || !formFieldTime || !timeFormControl || !timePickerContainer) {
    return
  }

  const dateInput = getDateInput(formFieldTime)
  const timePicker = new Picker(formFieldTime, {
    container: timePickerContainer,
    format: 'HH:mm',
    pick(event) {
      const input = event.target

      if (!validatePickerTime(input, dateInput)) {
        event.preventDefault()
        validateManualTime(input, dateInput)
        return
      }

      input.setCustomValidity('')
    },
    show(event) {
      const picker = event.target.picker.picker
      const pickerConfirm = picker.querySelector('.picker-confirm')

      if (pickerConfirm && !pickerConfirm.classList.contains('btn')) {
        pickerConfirm.classList.add('btn', 'btn-bounce', 'btn-bounce-primary')
      }

      timeFormControl.classList.add('time-picker-opened')
    },
    hidden() {
      timeFormControl.classList.remove('time-picker-opened')
    },
    text: {
      confirm:
        '<span class="btn-text">Сохранить</span>' +
        '<span class="btn-icon">' +
        '<svg class="icon"><use xlink:href="/img/sprite.svg#icon-arrow-top-right"></use></svg>' +
        '</span>',
      cancel: 'Закрыть <svg class="close-icon"><use xlink:href="/img/sprite.svg#icon-close"></use></svg>',
    },
  })

  formFieldTime.addEventListener('input', () => validateManualTime(formFieldTime, dateInput))
  formFieldTime.addEventListener('change', () => validateManualTime(formFieldTime, dateInput))

  if (dateInput) {
    const handleDateChange = () => {
      clearInvalidTimeOnToday(formFieldTime, dateInput)
      validateManualTime(formFieldTime, dateInput)
    }

    dateInput.addEventListener('change', handleDateChange)
    dateInput.addEventListener('date-picker:change', handleDateChange)
  }

  timeFormControl.addEventListener('click', (event) => {
    if (typeof $ === 'function') {
      $('.form-field__date').each(function () {
        const pickerInstance = $(this).pickadate('picker')

        if (pickerInstance && pickerInstance.get('open')) {
          pickerInstance.close()
        }
      })
    }

    event.preventDefault()

    const isPickerConfirmation = event.target.closest('.picker-picked')
      || event.target.closest('.btn-text')

    if (isPickerConfirmation) {
      if (!validatePickerTime(formFieldTime, dateInput)) {
        validateManualTime(formFieldTime, dateInput)
        return
      }

      timePicker.pick()
    }

    if (event.target.classList.contains('close-icon')) {
      timePicker.hide()
    }
  })

  body.addEventListener('mousedown', (event) => {
    if (
      !event.target.closest('.time-form-control')
      && !event.target.closest('.time-picker-container')
      && !event.target.closest('.time-picker-opened')
      && timeFormControl.classList.contains('time-picker-opened')
    ) {
      timePicker.hide()
    }
  })
})
